import { render, staticRenderFns } from "./CutVideo.vue?vue&type=template&id=4bfa4197"
import script from "./CutVideo.vue?vue&type=script&lang=js"
export * from "./CutVideo.vue?vue&type=script&lang=js"
import style0 from "./CutVideo.vue?vue&type=style&index=0&id=4bfa4197&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports